export default __webpack_public_path__ + "static/media/leader_notes.dd24a6ea.pdf";